/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />
/// <reference path="../login/user.service.ts" />

module Eseebase {
    export class BuildingDataController implements angular.IController {
        public roomTypes: RoomTypeViewModel[];
        public indoorData: IndoorDataAgregated[];
        public outdoorBuildingParts: OutdoorDataAggregated[];
        public simBuildingParts: SimDataAggregated[];
        public filter: ModelFilterViewModel;
        public erroLoadingData: boolean;
        public errorLoadingOutdoorData: boolean;
        public errorLoadingSimData: boolean;
        public tab: string;
        public isLoading: boolean;
        public features: CompanyFeatureList;
        public tabs: TabModel[];
        public downloadUrl: string;
        $onInit = () => { };

        constructor(private $scope: ng.IScope,
            private buildingService: BuildingService,
            private floorPlanService: FloorPlanService,
            private $q: ng.IQService,
            private $timeout: ng.ITimeoutService,
            private $mdDialog: any,
            private $window: ng.IWindowService,
            private $rootScope: ng.IRootScopeService,
            private organizationSettingsService: OrganizationSettingsService,
            private $routeParams: any,
            private user: UserModel,
            private cookiesService: CookiesService,
            private organizationService: OrganizationService,
            private $sce: ng.ISCEService,
            private configuration: ConfigurationModel,
            private universalStorageService: UniversalStorageService
        ) {
            this.filter = this.buildingService.getFilters();
            this.tab = $routeParams.tab == null ? 'floorplan' : $routeParams.tab;
            if ($routeParams.companyNumber != null) {
                this.cookiesService.createCookie('company', $routeParams.companyNumber, null);
            }

            var vm = this;
            
            this.$rootScope.$on('filter-change', () => {
                vm.filter = buildingService.getFilters();
                vm.filterChanged();
            });

            function onScroll()
            {
                if ($('#wrapper').scrollTop() + window.innerHeight > $('#main').height() - 280) {
                    if (vm.tab == 'scannedimage') {
                        vm.$rootScope.$broadcast("scannedImageLoadMore", 1);
                    }
                    else if (vm.tab == 'maindrawing') {
                        vm.$rootScope.$broadcast("mainDrawingLoadMore");
                    }
                    else if (vm.tab == 'simmaindrawing') {
                        vm.$rootScope.$broadcast("mainDrawingLoadMoreSim");
                    }
                    else if (vm.tab == 'floorplan') {
                        vm.$rootScope.$broadcast("floorplanLoadMore", 1);
                    }
                    else if (vm.tab == 'universalstorage') {
                        vm.$rootScope.$broadcast("universalstorageLoadMore", 1);
                    }
                }
            }

            $window.addEventListener('scroll', onScroll, true);

            organizationSettingsService.getFeatures().then((features: CompanyFeatureList) => {
                vm.features = features;
                vm.filter.indoorBuildingPartType.groupBy = vm.features.includeIndoorData();
                vm.filter.category.groupBy = vm.features.includeOutdoorData();
                vm.filter.simFamilyTypeName.groupBy = vm.features.includeSimData();

                
                if (vm.buildingService.isTabSetup()) {
                    vm.tabs = vm.buildingService.getTabs(features);
                    vm.$timeout(t => {
                        vm.loadData();
                    });
                }
                else {
                    vm.tabs = vm.buildingService.getTabs(features);
                    vm.filterChanged();
                }
                
            });

            $scope.$on('$destroy', function () {
                $window.removeEventListener('scroll', onScroll, true);
            });
        }

        private setTabEnabled(tab: string, enabled: boolean) {
            for (var t of this.tabs) {
                if (t.name == tab) {
                    t.isEnabled = enabled;
                    break;
                }
            }
        }

        private getNextEnabledTab(tab: string, iterations: number) {
            if (iterations >= this.tabs.length) {
                return this.tabs[0]; //'floorplan'
            }
            for (var i = 0; i < this.tabs.length; i++) {
                if (this.tabs[i].name == tab) {
                    if (!this.tabs[i].isEnabled || !this.tabs[i].isShown) {
                        return this.getNextEnabledTab(this.tabs[(i == this.tabs.length - 1) ? 0 : i + 1].name, iterations + 1);
                    }
                    return this.tabs[i];
                }
            }
        }

        public loadData() {
            var activeTab = this.getNextEnabledTab(this.tab, 0);
            if (activeTab.name != this.tab) {
                window.location.href = activeTab.url;
                return;
            }

            switch (this.tab) {
                case 'indoor':
                    this.loadIndoorData();
                    this.$rootScope.$broadcast("loadIndoorData", 1);
                    break;
                case 'outdoor':
                    this.loadOutdoorData();
                    this.$rootScope.$broadcast("loadOutdoorData", 1);
                    break;
                case 'sim':
                    this.loadSimData();
                    this.$rootScope.$broadcast("loadSimData", 1);
                    break;
                case 'floorplan':
                    this.$rootScope.$broadcast("loadFloorplans", 1);
                    break;
                case 'maindrawing':
                    this.$rootScope.$broadcast("loadMainDrawings");
                    break;
                case 'simmaindrawing':
                    this.$rootScope.$broadcast("loadMainDrawingsSim");
                    break;
                case 'scannedimage':
                    this.$rootScope.$broadcast("loadScannedImages", 1);
                    break;
                case 'universalstorage':
                    this.$rootScope.$broadcast("loadUniversalStorage", 1);
                    break;
            }
        }

        public isAssociationSelected(): ng.IPromise<boolean> {
            var def = this.$q.defer();
            var vm = this;
            this.buildingService.hasMultipleAssociations().then(d => {
                if (d === false) {
                    def.resolve(true);
                }
                else {
                    def.resolve(vm.filter != null && vm.filter.association != null && !vm.filter.association.isEmpty())
                }
                
            });
            return <ng.IPromise<boolean>>def.promise;
        }

        public canUpload() {
            return this.user.roles.indexOf('Upload Model') > -1;
        }

        public getFiltersAsString() {
            var accessToken = this.cookiesService.readCookie('accessToken');
            return JSON.stringify({ 'filter': this.filter, 'access_token': accessToken });
        }

        public filterChanged() {
            this.indoorData = null;
            this.outdoorBuildingParts = null;
            this.simBuildingParts = null;

            this.filter.indoorBuildingPartType.groupBy = this.features.includeIndoorData();
            this.filter.category.groupBy = this.features.includeOutdoorData();
            this.filter.simFamilyTypeName.groupBy = this.features.includeSimData();

            var vm = this;
            var promisses = [];
            var def = this.$q.defer();
            promisses.push(this.floorPlanService.floorplansExist(this.filter).then(d => {
                vm.setTabEnabled('floorplan', d === true);
                def.resolve();
            }));
            promisses.push(this.buildingService.mainDrawingsExist(this.filter).then(d => {
                vm.setTabEnabled('maindrawing', d === true);
                def.resolve();
            }));
            promisses.push(this.buildingService.simMainDrawingsExist(this.filter).then(d => {
                vm.setTabEnabled('simmaindrawing', d === true);
                def.resolve();
            }));
            promisses.push(this.isAssociationSelected().then(dd => {
                if (dd === true) {
                    vm.buildingService.indoorDataExists(this.filter).then(d => {
                        vm.setTabEnabled('indoor', d === true);
                        def.resolve();
                    });
                    vm.buildingService.outdoorDataExists(this.filter).then(d => {
                        vm.setTabEnabled('outdoor', d === true);
                        def.resolve();
                    });
                    vm.buildingService.landscapeDataExists(this.filter).then(d => {
                        vm.setTabEnabled('sim', d === true);
                        def.resolve();
                    });
                    vm.setTabEnabled('scannedimage', this.features.includeScannedImages(this.filter.association.values));
                    vm.setTabEnabled('universalstorage', this.features.includeUniversalStorage(this.filter.association.values));
                }
                else {
                    vm.setTabEnabled('indoor', false);
                    vm.setTabEnabled('outdoor', false);
                    vm.setTabEnabled('sim', false);
                    vm.setTabEnabled('scannedimage', this.features.includeScannedImages());
                    vm.setTabEnabled('universalstorage', this.features.includeUniversalStorage());
                    def.resolve();
                }
            }));
            this.$q.all(promisses).then(d => {
                vm.loadData();
            });
        }

        public loadIndoorData() {
            if (this.isLoading)
            {
                return;
            }
            var vm = this;
            this.erroLoadingData = false;
            if (this.indoorData != null) {
                return;
            }
            this.isLoading = true;
            this.buildingService.filterIndoorData(this.filter).then((data: IndoorDataResponse) => {
                vm.roomTypes = data.roomTypes;
                vm.indoorData = data.buildingParts;
                vm.isLoading = false;
                vm.$timeout(() => vm.refreshGrid());
            }, () => {
                vm.erroLoadingData = true;
                vm.roomTypes = [];
                vm.indoorData = null;
                vm.isLoading = false;
                vm.$timeout(() => vm.refreshGrid());
            });
        }

        public loadOutdoorData() {
            var vm = this;
            if (this.filter == null || !this.filter.category.groupBy) {
                vm.outdoorBuildingParts = [];
                return;
            }
            if (this.outdoorBuildingParts != null && this.outdoorBuildingParts.length > 0) {
                return;
            }
            this.errorLoadingOutdoorData = false;
            this.outdoorBuildingParts = null;
            this.buildingService.filterOutdoorData(this.filter).then((bpData: OutdoorDataAggregated[]) => {
                vm.outdoorBuildingParts = bpData;
                vm.$timeout(() => vm.refreshGrid());
            }, () => {
                vm.errorLoadingOutdoorData = true;
                vm.outdoorBuildingParts = [];
                vm.$timeout(() => vm.refreshGrid());
            });
        }

        public loadSimData() {
            var vm = this;
            if (this.filter == null || !this.filter.simFamilyTypeName.groupBy) {
                vm.simBuildingParts = [];
                return;
            }
            if (this.simBuildingParts != null && this.simBuildingParts.length > 0) {
                return;
            }
            this.errorLoadingSimData = false;
            this.simBuildingParts = null;
            this.buildingService.filterSimData(this.filter).then((bpData: SimDataAggregated[]) => {
                vm.simBuildingParts = bpData;
                vm.$timeout(() => vm.refreshGrid());
            }, () => {
                vm.errorLoadingSimData = true;
                vm.simBuildingParts = [];
                vm.$timeout(() => vm.refreshGrid());
            });
        }

        public indoorToPdf() {
            var vm = this;
            var dialog = {
                templateUrl: '/app/dialog/pdf-download.html',
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                controller: function () {
                    this.urlObject = null;
                    this.fileName = 'indoor.pdf';
                    this.$mdDialog = vm.$mdDialog;
                    this.$sce = vm.$sce;
                    var self = this;
                    vm.buildingService.exportIndoorDataToPdf(vm.filter).then(d => {
                        self.urlObject = window.URL.createObjectURL(new Blob([d], { type: 'application/pdf' }));
                    });
                    this.close = function () {
                        if (self.urlObject != null) {
                            window.URL.revokeObjectURL(self.urlObject);
                        }
                        self.$mdDialog.cancel();
                    }
                },
                controllerAs: 'vm'
            };
            this.$mdDialog.show(dialog);
        }

        public outdoorToPdf() {
            var vm = this;
            var dialog = {
                templateUrl: '/app/dialog/pdf-download.html',
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                controller: function () {
                    this.urlObject = null;
                    this.fileName = 'outdoor.pdf';
                    this.$mdDialog = vm.$mdDialog;
                    this.$sce = vm.$sce;
                    var self = this;
                    vm.buildingService.exportOutdoorDataToPdf(vm.filter).then(d => {
                        self.urlObject = window.URL.createObjectURL(new Blob([d], { type: 'application/pdf' }));
                    });
                    this.close = function () {
                        if (self.urlObject != null) {
                            window.URL.revokeObjectURL(self.urlObject);
                        }
                        self.$mdDialog.cancel();
                    }
                },
                controllerAs: 'vm'
            };
            this.$mdDialog.show(dialog);
        }

        public landscapeToPdf() {
            var vm = this;
            var dialog = {
                templateUrl: '/app/dialog/pdf-download.html',
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                controller: function () {
                    this.urlObject = null;
                    this.fileName = 'landscape.pdf';
                    this.$mdDialog = vm.$mdDialog;
                    this.$sce = vm.$sce;
                    var self = this;
                    vm.buildingService.exportLandscapeDataToPdf(vm.filter).then(d => {
                        self.urlObject = window.URL.createObjectURL(new Blob([d], { type: 'application/pdf' }));
                    });
                    this.close = function () {
                        if (self.urlObject != null) {
                            window.URL.revokeObjectURL(self.urlObject);
                        }
                        self.$mdDialog.cancel();
                    }
                },
                controllerAs: 'vm'
            };
            this.$mdDialog.show(dialog);
        }

        public getRoomMeasure(collection: RoomMeasure[], roomNumber: string) {
            if (collection == null || roomNumber == null) {
                return null;
            }
            var match = collection.filter(f => f.roomNumber == roomNumber);
            if (match.length > 0) {
                return match[0].measure;
            }
            return null;
        };

        public convertToUnits(measure: number, units: string) {
            if (measure == null || measure == 0) {
                return null;
            }
            if (units.toLocaleLowerCase() == "meter") {
                measure = measure / 1000;
            }
            return measure.toFixed(1);
        }

        public hideIfZero(val: number, isDecimal: boolean) {
            if (val == 0) {
                return null;
            }
            return isDecimal ? val.toFixed(1) : val;
        }

        public refreshGrid() {
            $('.content-table').each(function (i, elm) {
                if ($(elm).find('tbody')[0].scrollHeight > 800) {
                    var scrollWidth = $(elm).find('tbody')[0].offsetWidth - $(elm).find('tbody tr')[0].offsetWidth;
                    $(elm).find('thead').css('padding-right', scrollWidth + 'px');
                }
            });
        }

    }

    BuildingDataController.$inject = ['$scope', 'BuildingService', 'FloorPlanService', '$q', '$timeout', '$mdDialog', '$window', '$rootScope', 'OrganizationSettingsService', '$routeParams', 'user', 'CookiesService', 'OrganizationService', '$sce', 'configuration', 'UniversalStorageService'];

    angular
        .module('eseebase')
        .controller('BuildingDataController', BuildingDataController);
}
